import { useNavigate } from 'react-router-dom';

export default function MenuItem({ title, imgSrc, navigateTo, isDisabled }) {
    const navigate = useNavigate();

    return (
        <div 
            className='mainMenu__item' 
            onClick={() => !isDisabled && navigateTo && navigate(navigateTo)}
            style={{ cursor: isDisabled ? 'default' : 'pointer' }}
        >
            <div className="mainMenu__item-body">
                {imgSrc ? (
                    <div className="mainMenu__item-img"><img src={imgSrc} alt={title} /></div>
                ) : (
                    <span>{title}<br /><b>В разработке</b></span>
                )}
            </div>
            {imgSrc && <h2>{title}</h2>}
        </div>
    );
}